import DoughnutLegend from './DoughnutLegend';

export default DoughnutLegend;
